import get from 'lodash/get';

function getMensagemDeErro(obj: any, defaultValue: string) {
  return get(obj, 'response.data.exception.message', defaultValue);
}

export default getMensagemDeErro;
